import React from 'react';

interface IButtonClassic {
  handleClick: () => void;
  className?: string;
  type?: 'button' | 'reset' | 'submit';
  children: React.ReactNode;
}

export const ButtonClassic = ({ handleClick, className = '', type = 'button', children }: IButtonClassic) => {
  return (
    <button onClick={handleClick} className={`px-6 py-3 rounded-3xl duration-200 ease-in-out ${className}`} type={type}>
      {children}
    </button>
  );
};
